export default "__VITE_ASSET__DU_R8Dfs__"